import { graphql } from "gql";

const CALL_BY_ID_QUERY = graphql(`
  query CallById($id: ID!) {
    call(id: $id) {
      ...Call
    }
  }
`);

export default CALL_BY_ID_QUERY;
